export enum EProductReservationTabs {
    configurationDocumentLink = 'configurationDocumentLink',
    configurationPlaceholder = 'configurationPlaceholder',
}
export enum EAtributeTypes {
    Object = 'Object',
    Organisation = 'Organisation',
    DocumentType = 'DocumentType',
    Phase = 'Phase',
    Workpackage = 'Workpackage',
    DisciplineCode = 'DisciplineCode',
    Deelproject = 'Deelproject'
}
export enum EProductReservationMethods {
    View = "ProdReservation_View",
    Manage = "ProdReservation_Manage"
}